<template>
    <span id="searchBarContainer">
        <button @click="this.$emit('kartenAuswahlActive', true)"><img src="@/assets/KartenIcons/Hydrant.svg" v-if="this.$props.mapObj == 'hydrant'"><img src="@/assets/KartenIcons/Sammelpunkte.png" v-if="this.$props.mapObj == 'hiw'"><img src="@/assets/KartenIcons/Sammelpunkte.png" v-if="this.$props.mapObj == 'sammelpunkte'"></button>
        <input v-model="this.suchString" type="text" placeholder="Hier suchen" id="searchbar" @keyup.enter="sucheStarten">
        <button @click="sucheStarten" class="fa">&#xf002;</button>
        <button id="menuButton" @click="this.$emit('kartenAuswahlActive', true)" class="fa" style="color: #a7a7a7">&#xf0c9;</button>
    </span>
</template>

<script>
export default {
  name: "Searchbar",
  props: {
    kartenAuswahlActive: Boolean,
    mapObj: String,
    rettungspunkte: Array,
    hydranten: Array,
    sammelpunkte: Array
  },
  data() {
    return {
      suchString: ""
    };
  },
  methods: {
    async sucheStarten() {
        let gefunden = false;
        if(this.$props.mapObj == "hiw"){
            gefunden = await this.suchenHIW();
        } else if(this.$props.mapObj == "hydrant"){
            gefunden = await this.suchenHydrant();
        } else if(this.$props.mapObj == "sammelpunkte"){
            gefunden = await this.suchenSammelpunkt();
        } else{
            if(this.$props.hydranten .length > 0){
                gefunden = await this.suchenHydrant();
            }
            if(!gefunden&&this.$props.rettungspunkte.length > 0){
                gefunden = await this.suchenHIW();
            }
            if(!gefunden&&this.$props.sammelpunkte.length > 0){
                gefunden = await this.suchenSammelpunkt();
            }
            if(!gefunden){
                gefunden = await this.sucheAdresse();
            }
        }
        if(!gefunden){
            await this.sucheAdresse();
        }
    },
    async sucheAdresse(){
        var search = this.suchString;

        if(search == ''){
            return;
        }

        try{
            const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(search)}`);
            const data = await response.json();

            if(data.length > 0){
            const firstResult = data[0];
            this.$emit('locationFound', { lat: parseFloat(firstResult.lat), lng: parseFloat(firstResult.lon) });
            return true;
            }
        } catch(error){
            console.error('Fehler bei der Adresssuche:', error);
        }
    },
    async suchenHIW() {
        const normalizeString = (str) => {
            return str.toUpperCase().replace(/[\s,./]/g, '');
        };

        let object;
        const objArray = this.suchString.split(' ');
        let foundObjects = [];

        const searchString = normalizeString(this.suchString);

        object = this.$props.rettungspunkte.find(o => normalizeString(o.RP_Nr.toString()).includes(searchString));

        if (object) {
            //this.zoom = 50;
            this.$emit('locationFound', { lat: object.position.y, lng: object.position.x });
            return true;
        } else {
            object = this.$props.rettungspunkte.find(o => normalizeString(o.Ortsbeschr.toString()).includes(searchString));

            if (object) {
            //this.zoom = 50;
            this.$emit('locationFound', { lat: object.position.y, lng: object.position.x });
            return true;
            } else {
            foundObjects = this.$props.rettungspunkte.slice();  // Kopiere das Array, um Mutation zu vermeiden
            this.$props.rettungspunkte.forEach((foundRettungspunktObject) => {
                let del = false;
                objArray.forEach((foundSingleObject) => {
                if (!normalizeString(foundRettungspunktObject.Ortsbeschr.toString()).includes(normalizeString(foundSingleObject)) && !del) {
                    const index = foundObjects.findIndex(x => x === foundRettungspunktObject);
                    if (index > -1) {
                    foundObjects.splice(index, 1);
                    del = true;
                    }
                }
                });
            });

            if (foundObjects.length > 0) {
                //this.zoom = 50;
                this.$emit('locationFound', { lat: foundObjects[0].position.y, lng: foundObjects[0].position.x });
                return true;
            }
            }
        }
    },
    async suchenHydrant() {
        const normalizeString = (str) => {
            return str.toUpperCase().replace(/[\s,./]/g, '');
        };

        let object;
        const objArray = this.suchString.split(' ');
        let foundObjects = [];

        const searchString = normalizeString(this.suchString);

        object = this.$props.hydranten.find(o => normalizeString(o.wasserquellenID.toString()).includes(searchString));

        if (object) {
            //this.zoom = 50;
            this.$emit('locationFound', { lat: object.positionX, lng: object.positionY });
            return true;
        } else {
            object = this.$props.hydranten.find(o => normalizeString(o.bemerkung.toString()).includes(searchString));

            if (object) {
            //this.zoom = 50;
            this.$emit('locationFound', { lat: object.positionX, lng: object.positionY });
            return true;
            } else {
            foundObjects = this.$props.hydranten.slice();  // Kopiere das Array, um Mutation zu vermeiden
            this.$props.hydranten.forEach((foundHydrantObject) => {
                let del = false;
                objArray.forEach((foundSingleObject) => {
                if (!normalizeString(foundHydrantObject.bemerkung.toString()).includes(normalizeString(foundSingleObject)) && !del) {
                    const index = foundObjects.findIndex(x => x === foundHydrantObject);
                    if (index > -1) {
                    foundObjects.splice(index, 1);
                    del = true;
                    }
                }
                });
            });

            if (foundObjects.length > 0) {
                //this.zoom = 50;
                this.$emit('locationFound', { lat: foundObjects[0].positionX, lng: foundObjects[0].positionY });
                return true;
            }
            }
        }
        console.log(object);
        },
    async suchenSammelpunkt() {
        const normalizeString = (str) => {
            return str.toUpperCase().replace(/[\s,./]/g, '');
        };

        let object;
        const objArray = this.suchString.split(' ');
        let foundObjects = [];

        const searchString = normalizeString(this.suchString);

        object = this.$props.sammelpunkte.find(o => normalizeString(o.id.toString()).includes(searchString));

        if (object) {
            //this.zoom = 50;
            this.$emit('locationFound', { lat: object.position.x, lng: object.position.y });
            return true;
        } else {
            object = this.$props.sammelpunkte.find(o => normalizeString(o.beschreibung.toString()).includes(searchString));
            if (object) {
            //this.zoom = 50;
                this.$emit('locationFound', { lat: object.position.x, lng: object.position.y });
                return true;
            } else {
            foundObjects = this.$props.sammelpunkte.slice();  // Kopiere das Array, um Mutation zu vermeiden
            this.$props.sammelpunkte.forEach((foundSammelpunktObject) => {
                let del = false;
                objArray.forEach((foundSingleObject) => {
                if (!normalizeString(foundSammelpunktObject.beschreibung.toString()).includes(normalizeString(foundSingleObject)) && !del) {
                    const index = foundObjects.findIndex(x => x === foundSammelpunktObject);
                    if (index > -1) {
                    foundObjects.splice(index, 1);
                    del = true;
                    }
                }
                });
            });

            if (foundObjects.length > 0) {
                //this.zoom = 50;
                this.$emit('locationFound', { lat: object.position.x, lng: object.position.y });
                return true;
            }
            }
        }
        console.log(object);
    },
  }
};
</script>

<style lang="scss" scoped>
#searchBarContainer{  
    transform: translate(-50%,-50%);
    left: 50% !important;
    margin: 0;
    width: auto;
    display: flex;
    justify-content: space-around;
    position: absolute;
    z-index: 450;
    top: 5vh;
    width: 94%;
    max-width: 367px;
    background-color: white;
    height: 3rem;
    border-radius: 90px;
    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.11);

    input{
        margin-top: 0.25rem;
        margin-bottom: 0.25rem;
        width: 63%;
        border: none;
        font-size: x-large;
        margin-left: 0.3rem;
    }

    button{
        background: none !important;
        border: none !important;
        height: 2.5rem;
        margin-top: 0.25rem;
        margin-bottom: 0.25rem;
        width: 2.5rem;
        font-size: x-large;

        img{
            height: 100%;
            border-radius: 50%;
        }
    }
}
</style>